<template>
<div>
  <div>
    <div>
      <el-button type="primary" size="mini" @click="pageChang(1)">查询</el-button>
      <el-button type="primary" size="mini" @click="handleApprovals(1)">审批</el-button>
      <el-button type="primary" size="mini" @click="handleApprovals(-1)">拒绝</el-button>
    </div>
    <div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="客户名称">
          <el-input v-model="where.customer_name" placeholder="请输入客户名称" size="mini"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="项目名称">
          <el-input :value="house_name" placeholder="请选择项目" size="mini" disabled></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="操作人">
          <el-input v-model="where.apply_user_name" placeholder="请输入操作人" size="mini"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="审批人">
          <el-input v-model="where.approval_user_name" placeholder="请输入审批人" size="mini"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="操作时间">
          <el-date-picker v-model="where.apply_time" type="daterange" placeholder="选择操作时间" size="mini"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="审批时间">
          <el-date-picker v-model="where.approval_time" type="daterange" placeholder="选择审批时间" size="mini"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-select v-model="where.status" placeholder="请选择状态"  size="mini">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审批" value="0"></el-option>
            <el-option label="已审批" value="1"></el-option>
            <el-option label="已拒绝" value="-1"></el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
  <div>
    <el-table v-loading="isLoading" :data="pageData.data" style="width: 100%" height="50vh" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" prop="id" label="ID" width="80" align="center"></el-table-column>
      <el-table-column prop="project_name" label="项目名称" width="200" align="center"></el-table-column>
      <el-table-column prop="customer_name" label="业户名称" width="120" align="center"></el-table-column>
<!--      <el-table-column prop="form_before" label="变动前" width="300">-->
<!--        <template slot-scope="scope">-->
<!--          <div style="max-height: 100px;overflow: auto;" :ref="'before_'+scope.$index">-->
<!--            <pre>{{scope.row.form_before}}</pre>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="form_after" label="变动后" width="300">-->
<!--        <template slot-scope="scope">-->
<!--          <div style="max-height: 100px;overflow: auto;" :ref="'after_'+scope.$index">-->
<!--            <pre>{{scope.row.form_after}}</pre>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column prop="form_after" label="数据详情" width="100">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDetail(scope.row)">详情</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="apply_user_name" label="操作人名称" width="120" align="center"></el-table-column>
      <el-table-column prop="apply_time" label="申请时间" width="200" align="center"></el-table-column>
      <el-table-column prop="approval_user_name" label="审批人名称" width="120" align="center"></el-table-column>
      <el-table-column prop="approval_time" label="审批时间" width="200" align="center"></el-table-column>
      <el-table-column prop="status_text" label="状态" width="80" align="center"></el-table-column>
      <el-table-column prop="mode_type_text" label="操作方式" width="80" align="center"></el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="150" align="center"></el-table-column>
      <el-table-column prop="update_time" label="修改时间" width="150" align="center"></el-table-column>
      <el-table-column label="操作" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" v-if="scope.row.status === 0" @click="handleApproval(scope.row,1)">审批</el-button>
          <el-button type="danger" size="mini" v-if="scope.row.status === 0" @click="handleApproval(scope.row,-1)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination">
    <el-select v-model="pageData.per_page" placeholder="每页显示条数" size="mini" style="width: 80px">
      <el-option v-for="item in [20, 50, 100, 200, 500]" :key="item" :label="item+'条'" :value="item"></el-option>
    </el-select>
    <el-pagination
      layout="prev, pager, next"
      :current-page="pageData.page"
      :page-size="pageData.per_page"
      :total="pageData.total"
      @current-change="pageChang"></el-pagination>
  </div>
  <customer-preview ref="customerPreview" />
</div>
</template>

<script>

import Http from "../common/Http";
import CustomerPreview from "./preview/customer-preview";

export default {
  name: "CustomerTempFormList",
  components: {CustomerPreview},
  inject: ["mainObj"],
  data() {
    return {
      isLoading: false,
      where:{
        customer_name: "",
        apply_user_name: "",
        approval_user_name: "",
        apply_time: "",
        approval_time: "",
        status: "0"
      },
      pageData:{
        page:1,
        per_page:20,
        total:0,
        data:[]
      },
      multipleSelection:[]
    }
  },
  mounted() {
    this.pageChang(1);
  },
  methods: {
    getList(){
      const that = this;
      this.isLoading = true;
      Http.get("/admin/CustomerTempForm/index",{
        ...that.where,
        project_id: that.mainObj.project_id,
        page:that.pageData.page,
        per_page:that.pageData.per_page
      },(res) => {
        that.isLoading = false;
        if(res.code){
          res.data.data.map(item => {
            item.form_before = JSON.parse(item.form_before);
            item.form_after = JSON.parse(item.form_after);
          })
          that.pageData = {
            ...that.pageData, // 保留原有数据，避免覆盖非响应字段
            ...res.data // 合并响应数据
          };
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    pageChang(value) {
      this.pageData.page = value;
      this.getList();
    },
    handleApproval(row,status) {
      const that = this;
      that.multipleSelection = [row];
      that.handleApprovals(status);
    },
    handleApprovals(status) {
      const that = this;
      this.isLoading = true;
      Http.post("/admin/CustomerTempForm/approvals",{
        ids:that.multipleSelection.filter(item => item.status === 0).map(item => item.id).join(","),
        status:status
      },(res) => {
        that.isLoading = false;
        if(res.code){
          that.multipleSelection=[];
          that.getList();
          that.$message.success("操作成功");
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDetail(row) {
      this.$refs.customerPreview.show({
        ...row,
      });
    }
  },
  computed:{
    house_name(){
      return this.mainObj.house_name;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.pagination{
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/CustomerTempFormList.vue